import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import {
    Grid,
    Box,
    Typography,
    TextField,
    Button,
    useMediaQuery,
    useTheme,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from "@mui/material";

import ConferenceNavbar from "../../../frontend/Conference/ConferenceNavbar";
import NewVersionAbstractFooter from "../../AbstractAuth/NewVersion/NewVersionAnstractFooter";
import { useDeadline } from "../../../contexts/DeadlineContext";

const EvaluationFormVerification = () => {
    const { abstractHomeSetup } = useDeadline();
    const history = useHistory();
    const eventid = localStorage.getItem("eventid");

    const [verifyBy, setVerifyBy] = useState("email");
    const [emailData, setEmailData] = useState({ email: "", error_list: [] });
    const [qrCodeId, setQrCodeId] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const gradientBackground = "#05597D";

    // Validation effect
    useEffect(() => {
        if (verifyBy === "email") {
            const isValid = emailData.email && !emailData.error_list.email;
            setIsButtonDisabled(!isValid);
        } else {
            setIsButtonDisabled(!qrCodeId.trim());
        }
    }, [emailData, qrCodeId, verifyBy]);

    // Email input handler
    const handleInput = (e) => {
        const { name, value } = e.target;
        setEmailData({ ...emailData, [name]: value });

        if (name === "email") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            setEmailData((prev) => ({
                ...prev,
                error_list: {
                    ...prev.error_list,
                    email: emailRegex.test(value) ? "" : "Please enter a valid email address",
                },
            }));
        }
    };

    // Form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        const data = {
            eventid,
            email: verifyBy === "email" ? emailData.email : "",
            qrcode_id: verifyBy === "qrcode" ? qrCodeId : "",
        };

        if (verifyBy === "email") {
            localStorage.setItem("conference_particpant_email", emailData.email);
        }

        axios.post("api/conference-verify-evalution-email", data).then((res) => {
            if (res.data.redirect === 0) {
                // Payment verified, redirect
                const participant = res.data.checkEmail;
                const id = participant.id;
                history.push({
                    pathname: `/conference/evaluate-from`,
                   // pathname: `/conference/evaluate-from/${id}`,
                    state: {
                        participant ,
                        id
                    }
                });

            } else {
                // Show message from backend (either payment not done or user not found)
                swal(
                    "Warning",
                    res.data.message || "No attendee found for the provided information.",
                    "warning"
                );
            }
        });
    };

    return (
        <div>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <ConferenceNavbar />
            </Grid>

            <Grid container spacing={2}>
                <Box sx={{ width: "100%", mt: "3%" }}>
                    <Typography
                        variant={isSmallScreen ? "h6" : "h2"}
                        component="div"
                        sx={{ textAlign: "center" }}
                    >
                        Evaluation
                    </Typography>
                </Box>

                <Grid container justifyContent="center" marginTop="40px">
                    <Grid item xs={12} sm={10} md={8} lg={6}>
                        <Box
                            component="form"
                            onSubmit={handleSubmit}
                            sx={{
                                boxShadow: 3,
                                borderRadius: 2,
                                padding: 4,
                                width: "100%",
                                maxWidth: isSmallScreen ? "300px" : "600px",
                                textAlign: "center",
                                background: abstractHomeSetup?.color_code_four || gradientBackground,
                                color: "white",
                                marginX: "auto",
                                "@media (min-width: 960px)": {
                                    maxWidth: "800px",
                                },
                            }}
                        >
                            <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
                                Select Verification Method
                            </Typography>

                            {/* Verification Method Selection */}
                            <FormControl fullWidth sx={{ mt: 2, mb: 2 }}>
                                <InputLabel id="verify-method-label" sx={{ color: "white" }}>
                                    Verify By
                                </InputLabel>
                                <Select
                                    labelId="verify-method-label"
                                    id="verifyBy"
                                    value={verifyBy}
                                    onChange={(e) => setVerifyBy(e.target.value)}
                                    label="Verify By"
                                    sx={{
                                        color: "white",
                                        borderRadius: "25px",
                                        '& .MuiOutlinedInput-notchedOutline': { borderColor: "white" },
                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: "white" },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: "white" },
                                        '& svg': { color: 'white' } // <-- makes the dropdown icon white
                                    }}
                                >
                                    <MenuItem value="email">Email</MenuItem>
                                    <MenuItem value="qrcode">QR Code ID</MenuItem>
                                </Select>
                            </FormControl>

                            {/* Email Input */}
                            {verifyBy === "email" && (
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    autoComplete="off"
                                    id="email"
                                    label="Email Address"
                                    name="email"
                                    autoFocus
                                    onChange={handleInput}
                                    value={emailData.email}
                                    helperText={emailData.error_list.email}
                                    InputLabelProps={{ style: { color: "white" } }}
                                    FormHelperTextProps={{ style: { color: "white" } }}
                                    InputProps={{ style: { color: "white" } }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: "25px",
                                            color: "white",
                                            '& fieldset': { borderColor: "white" },
                                            '&:hover fieldset': { borderColor: "white" },
                                            '&.Mui-focused fieldset': { borderColor: "white" },
                                        },
                                    }}
                                />
                            )}

                            {/* QR Code ID Input */}
                            {verifyBy === "qrcode" && (
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    autoComplete="off"
                                    id="qrCodeId"
                                    label="QR Code ID"
                                    name="qrCodeId"
                                    value={qrCodeId}
                                    onChange={(e) => setQrCodeId(e.target.value)}
                                    InputLabelProps={{ style: { color: "white" } }}
                                    InputProps={{ style: { color: "white" } }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: "25px",
                                            color: "white",
                                            '& fieldset': { borderColor: "white" },
                                            '&:hover fieldset': { borderColor: "white" },
                                            '&.Mui-focused fieldset': { borderColor: "white" },
                                        },
                                    }}
                                />
                            )}

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                disabled={isButtonDisabled}
                                sx={{
                                    mt: 3,
                                    mb: 2,
                                    background: abstractHomeSetup?.color_code_two || gradientBackground,
                                    borderRadius: "25px",
                                }}
                            >
                                Verify
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} sm={10} md={8} lg={6} marginTop="40px">
                <NewVersionAbstractFooter />
            </Grid>
        </div>
    );
};

export default EvaluationFormVerification;
